import { useRef, useEffect, useLayoutEffect } from "react";

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default function usePrevious<T>(value: T) {
    const ref = useRef<T>(null);
    useIsomorphicLayoutEffect(() => {
        ref.current = value;
    });
    return ref.current as T;
}
